export default __webpack_public_path__ + "static/media/home.831db11d.svg";